import React, { useState } from 'react';
import { API_BASE_URL } from '../config';
import { useAuth } from '../contexts/AuthContext';

const AhriAssistant = () => {
  const { getAuthHeaders } = useAuth();
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [debug, setDebug] = useState(null);
  const [loading, setLoading] = useState(false);

  const ask = async (e) => {
    e.preventDefault();
    const q = (question || '').trim();
    if (!q) return;
    setLoading(true);
    setAnswer(''); setDebug(null);
    try {
      const r = await fetch(`${API_BASE_URL}/api/v1/ahri/assistant/query`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ question: q })
      });
      const j = await r.json();
      if (r.ok) {
        setAnswer(j.answer || '');
        setDebug(j.debug || null);
      } else {
        setAnswer(j?.detail || 'Failed');
      }
    } catch (e) {
      setAnswer('Request failed');
    } finally {
      setLoading(false);
    }
  };

  const totalMs = debug?.total_ms || 0;
  const grouped = (debug?.steps || []).reduce((acc, s) => {
    const k = s.name;
    acc[k] = acc[k] || { count: 0, total: 0 };
    acc[k].count += 1; acc[k].total += (s.ms||0);
    return acc;
  }, {});

  return (
    <div className="container py-3">
      <h5 className="mb-3">AHRI Assistant</h5>
      <form onSubmit={ask} className="mb-3">
        <div className="input-group">
          <input className="form-control" placeholder="Ask a question about AHRI data..." value={question} onChange={(e)=>setQuestion(e.target.value)} />
          <button className="btn btn-primary" type="submit" disabled={loading}>{loading ? 'Asking...' : 'Ask'}</button>
        </div>
      </form>
      {answer && (
        <div className="card mb-3"><div className="card-body"><div style={{whiteSpace:'pre-wrap'}}>{answer}</div></div></div>
      )}
      {debug && (
        <div className="accordion" id="ahriDebug">
          <div className="accordion-item">
            <h2 className="accordion-header" id="hd-steps">
              <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#bd-steps" aria-expanded="true" aria-controls="bd-steps">
                Timing (ms) – Total: {totalMs}
              </button>
            </h2>
            <div id="bd-steps" className="accordion-collapse collapse show" aria-labelledby="hd-steps" data-bs-parent="#ahriDebug">
              <div className="accordion-body">
                <div className="table-responsive">
                  <table className="table table-sm align-middle">
                    <thead><tr><th>Step</th><th>Variant</th><th>ms</th></tr></thead>
                    <tbody>
                      {(debug.steps||[]).map((s, idx)=> (
                        <tr key={idx}><td>{s.name}</td><td>{s.variant||''}</td><td>{s.ms}</td></tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="mt-2">
                  <strong>Aggregates</strong>
                  <div className="table-responsive mt-1">
                    <table className="table table-sm"><thead><tr><th>Step</th><th>Count</th><th>Total</th><th>Avg</th></tr></thead><tbody>
                      {Object.entries(grouped).map(([k,v])=> (
                        <tr key={k}><td>{k}</td><td>{v.count}</td><td>{v.total}</td><td>{Math.round(v.total/Math.max(1,v.count))}</td></tr>
                      ))}
                    </tbody></table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="hd-matches">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#bd-matches" aria-expanded="false" aria-controls="bd-matches">
                Vector Matches (debug)
              </button>
            </h2>
            <div id="bd-matches" className="accordion-collapse collapse" aria-labelledby="hd-matches" data-bs-parent="#ahriDebug">
              <div className="accordion-body">
                <pre style={{whiteSpace:'pre-wrap', maxHeight: 260, overflowY: 'auto'}}>{JSON.stringify(debug.matches, null, 2)}</pre>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AhriAssistant;
